<template>
  <div class="content-i">
    <div class="content-box">
      <div class="row">
        <div class="col-lg">
          <div class="element-wrapper">
            <h6 class="element-header">Voucher Atendimento</h6>
            <div class="element-box">
              <form @submit.prevent="busca" autocomplete="off">
                <h5 class="form-header">Validar Voucher Atendimento DrAchei</h5>
                <div class="form-desc">
                  Informe o número do voucher apresentado para validar o atendimento.
                </div>

                <div class="row" v-if="error">
                  <div class="col">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <i class="fas fa-exclamation-triangle"></i>
                      <strong>{{error.message}}</strong>
                    </div>
                  </div>
                </div>
                <br>
                <div class="form-group col-md-6">
                  <label class="sr-only" for="nrCartao">Número Voucher</label>
                  <div class="input-group mb-2">
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="fas fa-ticket-alt"></i>
                      </div>
                    </div>
                    <input autofocus required type="text" class="form-control" id="nrCartao"
                      v-model="codigo" ref="codigo"
                      placeholder="Código do Voucher">
                    <div class="input-group-prepend">
                      <button class="btn btn-outline-secondary" type="submit">
                        <i class="fas fa-search"></i>
                        <span>Validar</span>
                      </button>
                      <button v-if="pedido" type="button" class="btn btn-outline-danger" @click.stop="cancelar">
                        <i class="fas fa-times-circle"></i>
                        <span>Limpar</span>
                      </button>
                    </div>
                  </div>
                </div>

                <hr>
                <div v-if="pedido">
                  <div class="row" v-if="pagamentoNaoRealizado">
                    <div class="col">
                      <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        <i class="fas fa-exclamation-triangle"></i>
                        <strong>O Pagamento deste Voucher não foi realizado. Favor não atender. Dúvidas entre em contato com a central de atendimento 21 2263-9325</strong>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="exibeBotaoRealizarAtendimento">
                    <div class="col text-center">
                      <button @click="realizarAtendimento" type="button" class="btn btn-success">
                        <i class="fa fa-notes-medical"></i>
                        Realizar Atendimento
                      </button>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <h6 class="form-header">Dados do Cliente</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label>Nome</label>
                      <b><p>{{pedido.cliente.name}}</p></b>
                    </div>
                    <div class="col">
                      <label>CPF</label>
                      <b><p>{{formataCPF(pedido.cliente.cpf)}}</p></b>
                    </div>
                  </div>

                  <template v-if="pedido.dependente">
                  <div class="row">
                    <div class="col">
                      <h6 class="form-header">Dependente para atendimento</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label>Nome</label>
                      <b><p>{{pedido.dependente.name}}</p></b>
                    </div>
                    <div class="col">
                      <label>CPF</label>
                      <b><p>{{formataCPF(pedido.dependente.cpf)}}</p></b>
                    </div>
                  </div>
                  </template>

                  <div class="row">
                    <div class="col">
                      <h6 class="form-header">Dados do pagamento</h6>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col">
                      <label>Forma de pagamento</label>
                      <p><b>{{pedido.tipoPagamento}}</b></p>
                    </div>
                    <div class="col" :class="{'text-danger':pedido.pagamentoAto}">
                      <label>{{pedido.pagamentoAto ? 'Valor a pagar' : 'Valor Pago'}}</label>
                      <p><b>{{pedido.valorTotal | money}}</b></p>
                    </div>
                    <div class="col">
                      <label>Status</label>
                      <p><b>{{statusPagamento}}</b></p>
                    </div>
                    <div class="col">
                      <label>Atendimento</label>
                      <p><b>{{pedido.statusAtendimento}}</b></p>
                    </div>
                  </div>

                  <template v-if="pedido.agendamento && pedido.agendamento.agenda">
                    <div class="row">
                      <div class="col">
                        <h6 class="form-header">Dados do Agendamento</h6>
                      </div>
                    </div>

                    <div class="row">
                      <div class="col" v-if="pedido.profissional">
                        <label>Profissional</label>
                        <p><b>{{pedido.profissional.nome}}</b></p>
                      </div>
                      <div class="col">
                        <label>Data</label>
                        <p><b>{{pedido.agendamento.dataEscolhida}}</b></p>
                      </div>
                      <div class="col">
                        <label>Horário</label>
                        <p><b>{{pedido.agendamento.horarioEscolhido.horario}}</b></p>
                      </div>
                    </div>

                  </template>

                  <div class="row">
                    <div class="col">
                      <h6 class="form-header">Dados do pedido</h6>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col" v-if="pedido.consulta">
                      <label>Consulta</label>
                      <b><p>{{pedido.consulta.especialidade.nome}}</p></b>
                    </div>
                    <div class="col">
                      <label>Solicitação</label>
                      <b><p>{{formataData(pedido.createdAt)}}</p></b>
                    </div>
                  </div>
                  <div class="row" v-if="pedido.exames && pedido.exames.length > 0">
                    <div class="col-md-12">
                      <h6>Exames</h6>
                    </div>
                    <div class="col">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <td class="text-center">Descrição</td>
                            <td class="text-center">Preço</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="exame in pedido.exames" :key="exame._id">
                            <td>{{exame.nomeExame}}</td>
                            <td class="text-center">{{getValor(exame) | money}}</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td class="text-right">Total:</td>
                            <td class="text-center">{{pedido.valorTotal | money}}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>


                </div>

              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import http from 'axios'
import moment from 'moment'

export default {
  created () {
    moment.locale('pt-br')
  },
  data () {
    return {
      pedido: null,
      error: null,
      codigo: null
    }
  },
  computed: {
    statusPagamento () {
      if (this.pedido) {
        switch (this.pedido.statusPagamento) {
          case 'INICIADO':
            return 'PAGAMENTO NÃO REALIZADO'
          case 'CONCLUIDO':
            return 'PAGO'
          default:
            return this.pedido.statusPagamento
        }
      } else {
        return null
      }
    },
    exibeBotaoRealizarAtendimento () {
      if (this.pedido.pagamentoAto && this.pedido.statusAtendimento !== 'REALIZADO') {
        return true
      }
      return this.pedido.statusPagamento === 'CONCLUIDO' && this.pedido.statusAtendimento !== 'REALIZADO'
    },
    pagamentoNaoRealizado () {
      return this.pedido.statusPagamento === 'INICIADO' && !this.pedido.pagamentoAto
    }
  },
  methods: {
    busca () {
      this.$store.dispatch('setLoading', true)
      http.get(`/pedidos?codigo=${this.codigo.toUpperCase()}&populate=cliente unidade profissional`)
        .then(response => {
          if (response.data.length === 0) {
            this.pedido = null
            this.error = {message: 'Voucher não encontrado. Favor entrar em contato com a central de atendimento 21 2263-9325'}
            this.$store.dispatch('setLoading', false)
          } else {
            let tmpPedido = response.data[0]
            if (tmpPedido.unidade._id !== this.$store.getters.rede._id) {
              this.error = {message: 'Voucher não pertence a Unidade informada. Favor entrar em contato com a central de atendimento 21 2263-9325'}
              this.$store.dispatch('setLoading', false)
            } else {
              this.pedido = tmpPedido
              this.error = null
              this.$store.dispatch('setLoading', false)
            }
          }
        })
        .catch(error => {
          this.pedido = null
          this.error = error.response.data
          this.$store.dispatch('setLoading', false)
        })
    },
    realizarAtendimento () {
      if (this.pedido.pagamentoAto) {
        if (confirm('Pagamento a ser recebido no estabelecimento. Confirma o recebimento?')) {
          this.$store.dispatch('setLoading', true)
          http.post(`/pedidos/${this.pedido._id}/realizarAtendimento`)
            .then(response => {
              this.$store.dispatch('showSuccessMsg', {body: 'Voucher validado com sucesso! Liberado atendimento.'})

              http.get(`/pedidos/${this.pedido._id}?populate=cliente unidade`)
                .then(response => {
                  this.$store.dispatch('setLoading', false)
                  this.pedido = response.data
                })
            })
        }
      } else {
        this.$store.dispatch('setLoading', true)
        http.post(`/pedidos/${this.pedido._id}/realizarAtendimento`)
          .then(response => {
            this.$store.dispatch('showSuccessMsg', {body: 'Voucher validado com sucesso! Liberado atendimento.'})
            http.get(`/pedidos/${this.pedido._id}?populate=cliente unidade`)
              .then(response => {
                this.$store.dispatch('setLoading', false)
                this.pedido = response.data
              })
          })
          .catch(() => {
            this.$store.dispatch('setLoading', false)
          })
      }
    },
    formataData (data) {
      return moment(data).format('DD/MM/YYYY')
    },
    formataCPF (cpf) {
      if (!cpf || cpf.length < 11) return ''
      return cpf.replace(/(\d\d\d)(\d\d\d)(\d\d\d)(\d\d)/g, '$1.$2.$3-$4')
    },
    getValor (exame) {
      return this.pedido.tipoPagamento === 'Drachei' ? exame.valorDrAchei : exame.valorSinSaude
    },
    cancelar () {
      this.pedido = null
      this.codigo = null
      this.$nextTick(() => this.$refs.codigo.focus())
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/dashboard/ValidacaoVoucher.vue